export default function crop(
    arr: [number, number][],
    begin: number,
    end: number = Number.MAX_SAFE_INTEGER
): [number, number][] {
    if (arr.length > 0 && begin < end) {
        let cropStart = 0
        let cropEnd = arr.length - 1

        // Special case for when there is only one item in the list
        if (arr[cropEnd][0] < begin || arr[0][0] > end) {
            return []
        }

        while (cropStart < cropEnd && arr[cropStart][0] < begin) {
            cropStart++
        }

        while (cropStart < cropEnd && arr[cropEnd][0] > end) {
            cropEnd--
        }

        if (cropEnd === cropStart) {
            return cropEnd === 0 ? [] : [arr[cropEnd]]
        }

        if (cropStart > 0 || cropEnd < arr.length - 1) {
            return arr.slice(cropStart, cropEnd + 1)
        }
    }

    return arr
}
